module.exports = __webpack_public_path__ + "static/media/studio_rotating_telehandler_mrt_1645_manitou_003.a85248f3.png";